import React from 'react';
import HeroBannerV2 from '@ajat/design-system/ContentBlocks/HeroBannerV2';
import { ComponentPage, DemoCard } from '../../shared';
import heroDesktop from '../../../../../assets/cls-dk/landing/Hero-Banner-Desktop.jpg';
import heroMobile from '../../../../../assets/cls-dk/landing/Hero-Banner-Mobile.jpg';

export const meta = {
  component: HeroBannerV2,
  title: 'Hero Banner V2',
  group: 'Content Blocks',
  importPath: '@ajat/design-system/ContentBlocks/HeroBannerV2',
  figmaNode: '8775:198358',
  description:
    'Full-photo hero — a 1360×600 box inside the layout gutters on desktop, full-bleed on mobile. Glass subtitle, editorial headline, copy, a white CTA and a secondary link. The darkening lives in the photos themselves, not in a CSS overlay. Used on the CLS-DK landing; other brands keep Hero Banner.',
  props: [
    ['subtitle', 'string', "''", 'Glass eyebrow above the headline (typo-h5)'],
    ['title', 'string', "''", 'Headline (typo-h1-editorial)'],
    ['copy', 'string', "''", 'Body copy'],
    ['ctaLabel', 'string', "''", 'CTA label'],
    ['ctaVariant', 'string', "'white'", 'Button variant'],
    ['ctaIcon', 'node', '<ArrowRight />', 'CTA icon'],
    ['ctaOnClick', 'func', '—', 'CTA handler'],
    ['ctaHref', 'string', '—', 'CTA link target'],
    ['secondaryLabel', 'string', "''", 'Second BUTTON next to the CTA (two equally weighted choices); the text link below is the lighter alternative'],
    ['secondaryVariant', 'string', "'black'", 'Variant of the secondary button'],
    ['secondaryIcon', 'node', '<ArrowRight />', 'Secondary button icon'],
    ['secondaryOnClick', 'func', '—', 'Secondary button handler'],
    ['secondaryHref', 'string', '—', 'Secondary button link target'],
    ['linkLabel', 'string', "''", 'Secondary link label (Hyperlink large, white; under the CTA on mobile)'],
    ['linkHref', 'string', '—', 'Secondary link target'],
    ['linkOnClick', 'func', '—', 'Secondary link handler'],
    ['image', 'string', '—', 'Desktop photo'],
    ['imageMobile', 'string', '—', 'Mobile photo (falls back to image)'],
    ['imageAlt', 'string', "''", 'Alt text for the photo'],
    ['className', 'string', "''", 'Additional CSS class'],
  ],
  usage: [
    {
      title: 'On the CLS-DK landing',
      code: `import HeroBannerV2 from '@ajat/design-system/ContentBlocks/HeroBannerV2';

<HeroBannerV2
  subtitle="SKARPESTE PRISER MED PRISGARANTI"
  title="Design tøj til studietur og studenterkørsel"
  copy="En rejse, som skaber glæde og mindeværdige oplevelser."
  ctaLabel="Bestil Studieturtrøje"
  ctaOnClick={() => onMenuItemClick('menu_1', { toSchoolShop: true })}
  linkLabel="Oplev Studenterkørsel"
  linkOnClick={() => onMenuItemClick('menu_2', { toSchoolShop: true })}
  image={heroDesktop}
  imageMobile={heroMobile}
  imageAlt="Studietur og studenterkørsel"
/>`,
    },
  ],
};

export default function HeroBannerV2Page() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Full photo, CTA + link" flush>
        <HeroBannerV2
          subtitle="SKARPESTE PRISER MED PRISGARANTI"
          title="Design tøj til studietur og studenterkørsel"
          copy="En rejse, som skaber glæde og mindeværdige oplevelser."
          ctaLabel="Bestil Studieturtrøje"
          linkLabel="Oplev Studenterkørsel"
          image={heroDesktop}
          imageMobile={heroMobile}
          imageAlt="Studietur og studenterkørsel"
        />
      </DemoCard>
    </ComponentPage>
  );
}
